import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBoldTypography = styled(Typography)({
  fontWeight: 'bold',
});
